import { render, staticRenderFns } from "./c_home_video.vue?vue&type=template&id=36486ef0&scoped=true"
import script from "./c_home_video.vue?vue&type=script&lang=js"
export * from "./c_home_video.vue?vue&type=script&lang=js"
import style0 from "./c_home_video.vue?vue&type=style&index=0&id=36486ef0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36486ef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36486ef0')) {
      api.createRecord('36486ef0', component.options)
    } else {
      api.reload('36486ef0', component.options)
    }
    module.hot.accept("./c_home_video.vue?vue&type=template&id=36486ef0&scoped=true", function () {
      api.rerender('36486ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_video.vue"
export default component.exports